/*
  assets/nibec-selector-estante.js · W2 (18-oct-2026) · «Elige tu estante en 3 pasos»
  Arma los pasos 2 y 3 y la lista de modelos con el catálogo que el snippet deja en <script data-catalogo> (carga, alto, ancho, precio y nombre leídos de
  cada ficha; nunca descuentos). Un alto que tiene un solo modelo se descarta (títulos con las medidas en otro orden). Sin cambiar la URL ni el catálogo.
  Eventos: nibec_selector_paso (paso, valor, modelos) y nibec_selector_ver (handle, posicion, modelos) por Shopify.analytics y dataLayer.
*/
(function () {
  if (window.customElements && customElements.get('nibec-selector')) return;

  function publicar(nombre, datos) {
    try {
      if (window.Shopify && Shopify.analytics) Shopify.analytics.publish(nombre, datos);
    } catch (e) {}
    try {
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: nombre }, datos));
    } catch (e) {}
  }

  function crear(tag, clase, texto) {
    var el = document.createElement(tag);
    if (clase) el.className = clase;
    if (texto != null) el.textContent = texto;
    return el;
  }

  function miles(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  class NibecSelector extends HTMLElement {
    connectedCallback() {
      var datos = this.querySelector('[data-catalogo]');
      if (!datos) return;
      try {
        this.items = JSON.parse(datos.textContent);
      } catch (e) {
        return;
      }
      // Un alto con un solo modelo suele ser un título con las medidas en otro orden: no se ofrece.
      var cuenta = {};
      this.items.forEach(function (i) {
        cuenta[i.a] = (cuenta[i.a] || 0) + 1;
      });
      this.items = this.items.filter(function (i) {
        return cuenta[i.a] >= 2;
      });
      if (this.items.length < 4) return;

      this.max = Math.min(Math.max(Number(this.dataset.max) || 3, 2), 4);
      this.pasos = {
        carga: this.querySelector('[data-paso="carga"]'),
        alto: this.querySelector('[data-paso="alto"]'),
        ancho: this.querySelector('[data-paso="ancho"]')
      };
      this.res = this.querySelector('[data-resultado]');
      this.lista = this.querySelector('[data-lista]');
      this.estado = this.querySelector('[data-estado]');
      this.todos = this.querySelector('[data-todos]');
      this.sel = { carga: null, alto: null, ancho: null };

      this.pasos.carga.addEventListener('change', (e) => {
        var r = e.target;
        if (!r || r.type !== 'radio') return;
        this.sel.carga = { min: Number(r.dataset.min), max: Number(r.dataset.max), texto: r.nextElementSibling.textContent };
        this.sel.alto = null;
        this.sel.ancho = null;
        this.pintar('carga');
      });
      this.pasos.alto.addEventListener('change', (e) => {
        var r = e.target;
        if (!r || r.type !== 'radio') return;
        this.sel.alto = Number(r.value);
        this.sel.ancho = null;
        this.pintar('alto');
      });
      this.pasos.ancho.addEventListener('change', (e) => {
        var r = e.target;
        if (!r || r.type !== 'radio') return;
        this.sel.ancho = Number(r.value);
        this.pintar('ancho');
      });
      this.querySelector('[data-reiniciar]').addEventListener('click', () => this.reiniciar());
      this.lista.addEventListener('click', (e) => {
        var a = e.target.closest ? e.target.closest('a[data-handle]') : null;
        if (!a) return;
        publicar('nibec_selector_ver', {
          handle: a.dataset.handle,
          posicion: Number(a.dataset.posicion) || 0,
          modelos: this.coinciden().length,
          carga: this.sel.carga ? this.sel.carga.min + '-' + this.sel.carga.max : '',
          alto: this.sel.alto || 0,
          ancho: this.sel.ancho || 0
        });
      });
    }

    coinciden(hasta) {
      var s = this.sel;
      return this.items.filter(function (i) {
        if (s.carga && (i.kg < s.carga.min || i.kg > s.carga.max)) return false;
        if (hasta === 'carga') return true;
        if (s.alto && i.a !== s.alto) return false;
        if (hasta === 'alto') return true;
        if (s.ancho && i.w !== s.ancho) return false;
        return true;
      });
    }

    distintos(lista, campo) {
      var v = [];
      lista.forEach(function (i) {
        if (v.indexOf(i[campo]) < 0) v.push(i[campo]);
      });
      return v.sort(function (a, b) {
        return a - b;
      });
    }

    opciones(paso, valores, actual, nombre) {
      var cont = this.pasos[paso].querySelector('[data-opciones]');
      cont.textContent = '';
      valores.forEach(function (v) {
        var l = crear('label', 'nibec-sel__opcion');
        var r = document.createElement('input');
        r.type = 'radio';
        r.className = 'nibec-sel__radio';
        r.name = nombre;
        r.value = String(v);
        r.checked = v === actual;
        r.setAttribute('data-hm-id', 'selector-' + paso);
        l.appendChild(r);
        l.appendChild(crear('span', '', v + ' cm'));
        cont.appendChild(l);
      });
    }

    espera(paso, activo, ayuda) {
      var li = this.pasos[paso];
      li.classList.toggle('is-espera', !activo);
      li.querySelector('fieldset').disabled = !activo;
      var a = li.querySelector('[data-ayuda]');
      if (a && ayuda) a.textContent = ayuda;
      if (!activo) li.querySelector('[data-opciones]').textContent = '';
    }

    pintar(desde) {
      var s = this.sel;
      // Paso 2: altos que existen con esa carga. Paso 3: anchos que existen con esa carga y ese alto.
      if (s.carga) {
        var altos = this.distintos(this.coinciden('carga'), 'a');
        this.espera('alto', true, 'Alto del espacio disponible, en cm.');
        if (desde === 'carga') this.opciones('alto', altos, s.alto, 'nibec-sel-alto');
      } else {
        this.espera('alto', false, 'Elige primero el peso.');
      }
      if (s.carga && s.alto) {
        var anchos = this.distintos(this.coinciden('alto'), 'w');
        this.espera('ancho', true, 'Ancho del espacio disponible, en cm.');
        if (desde === 'alto' || desde === 'carga') this.opciones('ancho', anchos, s.ancho, 'nibec-sel-ancho');
      } else {
        this.espera('ancho', false, 'Elige primero el alto.');
      }
      if (desde === 'carga') this.espera('ancho', false, 'Elige primero el alto.');
      var lista = this.coinciden();
      var valor = desde === 'carga' ? s.carga.texto : desde === 'alto' ? s.alto + ' cm' : s.ancho + ' cm';
      publicar('nibec_selector_paso', { paso: desde, valor: valor, modelos: lista.length });
      this.resultado(lista);
      // Al terminar el último paso, la lista de modelos queda a la vista (en celular los pasos ocupan casi toda la pantalla).
      if (desde === 'ancho') {
        var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.res.scrollIntoView({ block: 'nearest', behavior: quieto ? 'auto' : 'smooth' });
      }
    }

    resultado(lista) {
      this.res.hidden = false;
      this.res.classList.remove('is-nuevo');
      void this.res.offsetWidth;
      this.res.classList.add('is-nuevo');
      var n = lista.length;
      this.estado.textContent = n === 1 ? '1 modelo cumple' : n + ' modelos cumplen';
      this.lista.textContent = '';
      lista.slice(0, this.max).forEach((p, idx) => {
        var li = crear('li', 'nibec-sel__item');
        var a = crear('a', 'nibec-sel__card');
        a.href = p.u;
        a.dataset.handle = p.h;
        a.dataset.posicion = String(idx + 1);
        a.setAttribute('data-hm-id', 'selector-resultado');
        var foto = crear('span', 'nibec-sel__foto');
        if (p.i) {
          var img = document.createElement('img');
          img.src = p.i;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 240;
          img.height = 240;
          foto.appendChild(img);
        }
        var cuerpo = crear('span', 'nibec-sel__cuerpo');
        cuerpo.appendChild(crear('span', 'nibec-sel__nombre', p.t));
        var medidas = p.a + ' × ' + p.w + (p.f ? ' × ' + p.f : '') + ' cm';
        cuerpo.appendChild(crear('span', 'nibec-sel__dato', miles(p.kg) + ' kg · ' + medidas));
        cuerpo.appendChild(crear('span', 'nibec-sel__precio', p.p));
        cuerpo.appendChild(crear('span', 'nibec-sel__ver', 'Ver estante'));
        a.appendChild(foto);
        a.appendChild(cuerpo);
        li.appendChild(a);
        this.lista.appendChild(li);
      });
      if (this.todos) {
        if (n > this.max) {
          this.todos.hidden = false;
          this.todos.textContent = 'Ver los ' + n + ' modelos en ' + (this.dataset.nombre || 'la colección');
        } else {
          this.todos.hidden = true;
        }
      }
    }

    reiniciar() {
      this.sel = { carga: null, alto: null, ancho: null };
      this.pasos.carga.querySelectorAll('input').forEach(function (r) {
        r.checked = false;
      });
      this.espera('alto', false, 'Elige primero el peso.');
      this.espera('ancho', false, 'Elige primero el alto.');
      this.res.hidden = true;
      this.lista.textContent = '';
      var primero = this.pasos.carga.querySelector('input');
      if (primero) primero.focus();
    }
  }

  if (window.customElements) customElements.define('nibec-selector', NibecSelector);
})();
